import { render, staticRenderFns } from "./OperadorasAEnviar.vue?vue&type=template&id=19dea35c&"
import script from "./OperadorasAEnviar.vue?vue&type=script&lang=js&"
export * from "./OperadorasAEnviar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports